import axios from 'axios';
import jwt from 'jsonwebtoken';
import { apiLib } from '../url-lib';


// const token = req.headers["authorization"]?.split(" ")[1];

let simulate = false;
let _temp_stored_token = null;
const config_solution = 'AXIOS';


export const _zzsurvey_authUtils = {};
export const _zzsurvey_ajax = {};
export const _zzsurvey_urlLib = {};


_zzsurvey_authUtils.getToken = () => {
  return _temp_stored_token;
};
_zzsurvey_authUtils.setToken = (token) => {
  _temp_stored_token = token;
  return _temp_stored_token;
};

// let token_value = 'Bearer ' + token;
// config.TOKEN_HEADER_KEY = 'X-AuthToken'; // name of the token in AJAX header (backend require 
// config.TOKEN_HEADER_KEY = 'Authorization'; // name of the token in AJAX header (backend require 
// 'Authorization' : 'Bearer ' + token,
// 'Authorization' : 'Bearer ' + _zzsurvey_authUtils.getToken(),

// `Content-Type: application/json; charset=utf-8`
/*
const CONTENT_TYPE_JSON = ajax_utils.CONTENT_TYPE_JSON; // 'application/json';
const initial_getmethod_headers_arr = [
  [key, value]
];
const initial_postmethod_headers_arr = [
  [key, value],
  ['Content-Type', CONTENT_TYPE_JSON]
];
const HEADER_KEY_CONTENT_TYPE = 'Content-Type';
*/
const CONTENT_TYPE_JSON = 'application/json';



// ---------- URL LIB
let local_config_url_prefix = 'http://localhost:9000';
if (window.location.host === "localhost:3000") {
  // stay default localhost backend API
} else if (window.location.host === "localhost:3001") {
  // stay default localhost backend API
} else if (window.location.host === "localhost:3002") {
  // stay default localhost backend API
} else {
  local_config_url_prefix = window.location.protocol + '//' + window.location.host;
}
_zzsurvey_urlLib.websitePrefix_set = (url) => {
  // WEBSITE PREFIX UKLJUCUJE CEO POCETAK URL-a (i podomen i domen) NA KOJEM SE HOSTUJE SAJT
  // let url = ''; // moze da bude i 'http://mojsajt.com' kasnije
  local_config_url_prefix = url; //
  return url;
};


_zzsurvey_urlLib.websitePrefix = () => {
  // WEBSITE PREFIX UKLJUCUJE CEO POCETAK URL-a (i podomen i domen) NA KOJEM SE HOSTUJE SAJT
  // let url = ''; // moze da bude i 'http://mojsajt.com' kasnije
  let url = local_config_url_prefix; // moze da bude i 'http://mojsajt.com' kasnije
  return url;
};

/*
/auth
router.post("/login", login);
router.post("/register", register);
router.post("/logout", logout);
*/

_zzsurvey_urlLib.login = () => {
  // router.post("/login", login);
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/auth/login'; // POST
  return url;
};
_zzsurvey_urlLib.logout = () => {
  // router.post("/logout", logout);
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/auth/logout'; // POST
  return url;
};
_zzsurvey_urlLib.register = () => {
  // router.post("/register", register);
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/auth/register'; // POST
  return url;
};

_zzsurvey_urlLib.loginbytoken = () => { // TODO NEW+++
  // router.post("/login", login);
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/auth/refresh'; // GET
  return url;
};

/*
/superadmin
router.post("/clients", createClient);
router.get("/clients", getAllClients);
router.patch("/clients/:id", updateClient);
router.patch("/clients/:id/status", activateClient);
router.delete("/clients/:id/status", deactivateClient);
router.post("/clients/:id/sellers", createSeller);
// NEW
router.get("/sellers/:id", getSeller);
router.get("/clients/:id/sellers", getAllSellersOfClient);
// NEW 2025-03-10
router.get("/sellers", getAllSellers);
router.post("/sellers/:id/bind", bindSellerToClients);
*/

_zzsurvey_urlLib.createClient = () => {
  // router.post("/clients", createClient); POST
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/superadmin/clients'; // POST
  return url;
};
_zzsurvey_urlLib.getAllClients = () => {
  // router.get("/clients", getAllClients); GET
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/superadmin/clients'; // GET
  return url;
};
_zzsurvey_urlLib.updateClient = (client_id) => {
  // router.patch("/clients/:id", updateClient); PATCH
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/superadmin/clients/' + client_id; // PATCH
  return url;
};
_zzsurvey_urlLib.activateClient = (client_id) => {
  // router.patch("/clients/:id/status", activateClient); PATCH
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/superadmin/clients/' + client_id + '/status'; // PATCH
  return url;
};
_zzsurvey_urlLib.deactivateClient = (client_id) => {
  // router.delete("/clients/:id/status", deactivateClient); DELETE
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/superadmin/clients/' + client_id + '/status'; // DELETE
  return url;
};
// only client can create seller TODO
_zzsurvey_urlLib.createSeller = (client_id) => {
  // router.post("/clients/:id/sellers", createSeller); POST
  // let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/superadmin/clients/' + client_id + '/sellers'; // POST
  // NEW 2025-03-10
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/superadmin/sellers'; // POST
  return url;
};
// NEW
_zzsurvey_urlLib.getSeller = (id) => {
  // router.get("/sellers/:id", getSeller); GET
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/superadmin/sellers/' + id; // GET
  return url;
};
_zzsurvey_urlLib.getAllSellersOfClient = (client_id) => {
  // router.get("/clients/:id/sellers", getAllSellersOfClient); GET
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/superadmin/clients/' + client_id + '/sellers'; // GET
  return url;
};
_zzsurvey_urlLib.getAllSellers = () => {
  // router.get("/sellers", getAllSellers); GET
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/superadmin/sellers'; // GET
  return url;
};
_zzsurvey_urlLib.bindSellerToClients = (seller_id) => {
  // router.post("/sellers/:id/bind", bindSellerToClients); POST
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/superadmin/sellers/' + seller_id + '/bind'; // POST
  return url;
};

/*
/customers
router.post("/", createCustomer);
router.get("/", getAllCustomersOfClient);
// NEW 2025-03-10
router.patch("/:id", updateCustomer);
router.delete("/:id", deleteCustomer);
// NEW 2025-03-17
/api/v1/customers/import
// NOVO 2025-07-12
router.post("/register", registerCustomer);
*/

_zzsurvey_urlLib.createCustomer = () => {
  // router.post("/", createCustomer); POST
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/customers'; // POST
  return url;
};
_zzsurvey_urlLib.registerCustomer = () => { // NOVO 2025-07-12 za anketu bez mejla
  // router.post("/register", registerCustomer); POST
  // {{base_url}}/api/v1/customers/register
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/customers/register'; // POST
  return url;
};
_zzsurvey_urlLib.getAllCustomersOfClient = (client_id) => {
  // router.get("/", getAllCustomersOfClient); GET
  // let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/customers'; // GET
  // NEW 2025-03-10
  /*
  [ 16. jul 2025 10:51 ] Jovan Petrović: Kad dohvatas kupce samo prosledi u url query jos i is_qr=false i api ti vraca vec filtrirano @Zarko Turicanin
  [ 16. jul 2025 10:53 ] Jovan Petrović: GET /api/v1/customers?customer_id=1 - ovo radi kao i pre, vraca sve kupce bez obzira na is_qr
  
  GET /api/v1/customers?customer_id=1&is_qr=false - vraca samo kupce koje je registrovao prodavac
  
  GET /api/v1/customers?customer_id=1&is_qr=true - vraca samo kupce koji su se sami registrovali
  */
  // let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/customers?client_id=' + client_id; // GET
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/customers?client_id=' + client_id + '&is_qr=false'; // GET
  return url;
};
_zzsurvey_urlLib.getAllCustomersOfClientQr = (client_id) => {
  // router.get("/", getAllCustomersOfClient); GET
  // let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/customers'; // GET
  // NEW 2025-03-10
  /*
  [ 16. jul 2025 10:51 ] Jovan Petrović: Kad dohvatas kupce samo prosledi u url query jos i is_qr=false i api ti vraca vec filtrirano @Zarko Turicanin
  [ 16. jul 2025 10:53 ] Jovan Petrović: GET /api/v1/customers?customer_id=1 - ovo radi kao i pre, vraca sve kupce bez obzira na is_qr
  
  GET /api/v1/customers?customer_id=1&is_qr=false - vraca samo kupce koje je registrovao prodavac
  
  GET /api/v1/customers?customer_id=1&is_qr=true - vraca samo kupce koji su se sami registrovali
  */
  // let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/customers?client_id=' + client_id; // GET
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/customers?client_id=' + client_id + '&is_qr=true'; // GET
  return url;
};
// NEW 2025-03-10
_zzsurvey_urlLib.updateCustomer = (customer_id) => {
  // router.patch("/:id", updateCustomer); PATCH
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/customers/' + customer_id; // PATCH
  return url;
};
_zzsurvey_urlLib.deleteCustomer = (customer_id) => {
  // router.delete("/:id", deleteCustomer); DELETE
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/customers/' + customer_id; // DELETE
  return url;
};
// NEW 2025-03-17
_zzsurvey_urlLib.importCustomers = (client_id) => {
  // /api/v1/customers/import POST
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/customers/import'; // POST
  return url;
};

/*
/surveys
  createSurvey, // NEW---
  createSurveyTemplate, // NEW+++
  getSurveyTemplate,
  getAllSurveyTemplatesOfClient,
  createSurveyInstances, // NEW
  createSurveyInstance, // NOVO 2025-07-12
  fillSurvey,
  getSurveyInstance,
  getAllSurveyInstancesOfClient,
*/

_zzsurvey_urlLib.createSurvey = () => {
  // "/templates", POST
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/surveys/templates'; // POST
  return url;
};
_zzsurvey_urlLib.createSurveyTemplate = () => {
  // "/templates", POST
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/surveys/templates'; // POST
  return url;
};
_zzsurvey_urlLib.getSurveyTemplate = (id) => {
  // "/templates/:id", GET
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/surveys/templates/' + id; // GET
  return url;
};
_zzsurvey_urlLib.getAllSurveyTemplatesOfClient = (client_id) => {
  // "/templates", GET
  // let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/surveys/templates'; // GET
  // NEW 2025-03-10
  // {{base_url}}/api/v1/surveys/templates?client_id=1
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/surveys/templates?client_id=' + client_id; // GET
  return url;
};
_zzsurvey_urlLib.createSurveyInstances = () => {
  // createSurveyInstances, {{base_url}}/api/v1/surveys/instances POST
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/surveys/instances'; // POST
  return url;
};
_zzsurvey_urlLib.createSurveyInstance = () => { // POST PUBLIC
  // createSurveyInstance, {{base_url}}/api/v1/surveys/instance POST
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/surveys/instance'; // POST
  return url;
};
_zzsurvey_urlLib.fillSurvey = (id) => {
  // router.post("/instances/:id", fillSurvey);
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/surveys/instances/' + id; // POST
  return url;
};
_zzsurvey_urlLib.getSurveyInstance = (id) => {
  // "/instances/:id", GET
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/surveys/instances/' + id; // GET
  return url;
};
_zzsurvey_urlLib.getAllSurveyInstancesOfClient = (status, client_id) => {
  // router.get("/instances",
  // {{base_url}}/api/v1/surveys/instances?status=filled
  // let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/surveys/instances?status=filled'; // GET
  // let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/surveys/instances'; // GET
  // status enum('pending','filled','expired') [pending]
  // let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/surveys/instances?status=pending'; // GET
  let _status_sufix = '';
  /*
  if (status === 'pending' || status === 'filled' || status === 'expired') {
    _status_sufix = '?status=' + status;
  }
  */
  // let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/surveys/instances?status=filled'; // GET
  // let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/surveys/instances' + _status_sufix; // GET
  //
  // NEW 2025-03-10
  // {{base_url}}/api/v1/surveys/instances?client_id=1
  if (status === 'pending' || status === 'filled' || status === 'expired') {
    _status_sufix = '&status=' + status;
  }
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/surveys/instances?client_id=' + client_id + _status_sufix; // GET
  return url;
};

/*
/google
  GetAllReviews {{base_url}}/api/v1/google/reviews
  PUT /api/v1/google/params
*/
_zzsurvey_urlLib.getAllReviews = () => {
  // {{base_url}}/api/v1/google/reviews, POST
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/google/reviews'; // POST
  return url;
};
_zzsurvey_urlLib.updateClientParams = () => {
  // PUT /api/v1/google/params, PUT
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/google/params'; // PUT
  return url;
};

/*
/cdp_customers
  {{base_url}}/api/v1/cdp_customers POST
  {{base_url}}/api/v1/cdp_customers?client_id=4 GET
  {{base_url}}/api/v1/cdp_customers/1 PATCH
  {{base_url}}/api/v1/cdp_customers/1 DELETE
  {{base_url}}/api/v1/cdp_customers/import POST
*/
_zzsurvey_urlLib.createCdpCustomer = () => {
  // {{base_url}}/api/v1/cdp_customers POST
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/cdp_customers'; // POST
  return url;
};
_zzsurvey_urlLib.getAllCdpCustomersOfClient = (client_id) => {
  // {{base_url}}/api/v1/cdp_customers?client_id=4 GET
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/cdp_customers?client_id=' + client_id; // GET
  return url;
};
_zzsurvey_urlLib.updateCdpCustomer = (customer_id) => {
  // {{base_url}}/api/v1/cdp_customers/1 PATCH
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/cdp_customers/' + customer_id; // PATCH
  return url;
};
_zzsurvey_urlLib.deleteCdpCustomer = (customer_id) => {
  // {{base_url}}/api/v1/cdp_customers/1 DELETE
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/cdp_customers/' + customer_id; // DELETE
  return url;
};
_zzsurvey_urlLib.importCdpCustomers = () => {
  // {{base_url}}/api/v1/cdp_customers/import POST
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/cdp_customers/import'; // POST
  return url;
};

/*
/consents
  {{base_url}}/api/v1/consents POST
  {{base_url}}/api/v1/consents?client_id=2 GET
  {{base_url}}/api/v1/consents/3 GET // TODO
*/
_zzsurvey_urlLib.createConsent = () => {
  // {{base_url}}/api/v1/consents POST
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/consents'; // POST
  return url;
};
_zzsurvey_urlLib.getAllConsentsOfClient = (client_id) => {
  // {{base_url}}/api/v1/consents?client_id=4 GET
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/consents?client_id=' + client_id; // GET
  return url;
};
_zzsurvey_urlLib.getConsent = (consent_id) => {
  // {{base_url}}/api/v1/consents/3 GET
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/consents/' + consent_id; // GET
  return url;
};

/*
/signatures
  createSignature
  {{base_url}}/api/v1/signatures POST

  generateSignatureUrl
  {{base_url}}/api/v1/signatures/url?cdp_customer_id=8&consent_id=10

  getAllSignaturesOfClient
  {{base_url}}/api/v1/signatures/client/3 GET

  getSignature
  {{base_url}}/api/v1/signatures/9 GET // TODO
*/
_zzsurvey_urlLib.createSignature = () => {
  // {{base_url}}/api/v1/signatures POST
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/signatures'; // POST
  return url;
};
_zzsurvey_urlLib.getAllSignaturesOfClient = (client_id) => {
  // {{base_url}}/api/v1/signatures/client/3 GET
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/signatures/client/' + client_id; // GET
  return url;
};
_zzsurvey_urlLib.generateSignatureUrl = (cdp_customer_id, consent_id) => {
  // {{base_url}}/api/v1/signatures/url?cdp_customer_id=8&consent_id=10 GET
  let url = _zzsurvey_urlLib.websitePrefix() + '/api/v1/signatures/url?cdp_customer_id=' + cdp_customer_id + '&consent_id=' + consent_id; // GET
  return url;
};


// ---------- AJAX ADAPTER

// --- /auth

_zzsurvey_ajax._get_test = async (data) => {
  const simEndpoint = 'login';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = apiLib.getComorditemList();
    return axios.get(url, data, {
      'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
      'Content-Type': CONTENT_TYPE_JSON,
    })
    // .catch((err) => { error_handle(err.response) })
  }
};


_zzsurvey_ajax.login = async (data) => { // POST
  const simEndpoint = 'login';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.login();
    return axios.post(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};
_zzsurvey_ajax.loginbytoken = async (data) => { // GET TODO NEW+++
  const simEndpoint = 'loginbytoken';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.loginbytoken();
    return axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        // 'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.logout = async () => { // POST
  const simEndpoint = 'logout';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.logout();
    return axios.post(url, {}, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.register = async (data) => { // POST
  const simEndpoint = 'register';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.register();
    return axios.post(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

// --- /superadmin

_zzsurvey_ajax.createClient = async (data) => { // POST
  const simEndpoint = 'createClient';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.createClient();
    return axios.post(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.getAllClients = async () => { // GET
  const simEndpoint = 'getAllClients';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.getAllClients();
    return axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

///
_zzsurvey_ajax.updateClient = async (client_id, data) => { // PATCH
  const simEndpoint = 'updateClient';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.updateClient(client_id);
    return axios.patch(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};
_zzsurvey_ajax.activateClient = async (client_id, data) => { // PATCH
  const simEndpoint = 'activateClient';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.activateClient(client_id);
    return axios.patch(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};
_zzsurvey_ajax.deactivateClient = async (client_id, hard) => { // DELETE
  const simEndpoint = 'deactivateClient';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.deactivateClient(client_id);
    // return axios.delete(url, {should_delete: true}, {
    axios.delete(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      },
      data: {
        should_delete: hard // true brise a false ga samo deaktivira
      }
    })
    /*
  headers: {
    'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
  }
})
*/
    // .catch((err) => { error_handle(err.response) })
  }
};
///
// TODO
_zzsurvey_ajax.createSeller = async (client_id, data) => { // POST
  const simEndpoint = 'createSeller';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.createSeller(client_id);
    return axios.post(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};
// NEW 2025-03-10
_zzsurvey_ajax.bindSellerToClients = async (seller_id, data) => { // POST
  const simEndpoint = 'bindSellerToClients';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.bindSellerToClients(seller_id);
    return axios.post(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};
// NEW
_zzsurvey_ajax.getSeller = async (id) => { // GET // TODO sta radi ovaj api??
  const simEndpoint = 'getSeller';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.getSeller(id);
    return axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        // 'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};
_zzsurvey_ajax.getAllSellersOfClient = async (client_id) => { // GET
  const simEndpoint = 'getAllSellersOfClient';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.getAllSellersOfClient(client_id);
    return axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};
// NEW 2025-03-10
_zzsurvey_ajax.getAllSellers = async () => { // GET
  const simEndpoint = 'getAllSellers';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.getAllSellers();
    return axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};


// --- /customers
/*
/customers
router.post("/", createCustomer);
router.get("/", getAllCustomersOfClient);
// NEW 2025-03-
router.patch("/:id", updateCustomer);
router.delete("/:id", deleteCustomer);
*/

_zzsurvey_ajax.createCustomer = async (data) => { // POST
  const simEndpoint = 'createCustomer';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.createCustomer();
    return axios.post(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.registerCustomer = async (data) => { // POST PUBLIC
  const simEndpoint = 'registerCustomer';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.registerCustomer();
    return axios.post(url, data, {
      headers: {
        // 'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        // 'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.getAllCustomersOfClient = async (client_id) => { // GET
  const simEndpoint = 'getAllCustomersOfClient';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.getAllCustomersOfClient(client_id);
    return axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.getAllCustomersOfClientQr = async (client_id) => { // GET
  const simEndpoint = 'getAllCustomersOfClientQr';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.getAllCustomersOfClientQr(client_id);
    return axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.updateCustomer = async (customer_id, data) => { // PATCH
  const simEndpoint = 'updateCustomer';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.updateCustomer(customer_id);
    return axios.patch(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.deleteCustomer = async (customer_id) => { // GET
  const simEndpoint = 'deleteCustomer';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.deleteCustomer(customer_id);
    return axios.delete(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};
// NEW 2025-03-17
_zzsurvey_ajax.importCustomers = async (data) => { // POST
  const simEndpoint = 'importCustomers';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.importCustomers();
    return axios.post(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

// --- /surveys

_zzsurvey_ajax.createSurvey = async (data) => { // NEW--- // POST
  const simEndpoint = 'createSurvey';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.createSurvey();
    return axios.post(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};
_zzsurvey_ajax.createSurveyTemplate = async (data) => { // NEW+++ // POST
  const simEndpoint = 'createSurveyTemplate';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.createSurveyTemplate();
    return axios.post(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.getSurveyTemplate = async (id) => { // GET
  const simEndpoint = 'getSurveyTemplate';
  if (simulate) {
    // TODO

  } else { // pravi backend

  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.getSurveyTemplate(id);
    return axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.getAllSurveyTemplatesOfClient = async (client_id) => { // GET
  const simEndpoint = 'getAllSurveyTemplatesOfClient';
  if (simulate) {
    // TODO

  } else { // pravi backend

  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.getAllSurveyTemplatesOfClient(client_id);
    return axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.createSurveyInstances = async (data) => { // NEW // POST
  const simEndpoint = 'createSurveyInstances';
  if (simulate) {
    // TODO

  } else { // pravi backend

  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.createSurveyInstances();
    return axios.post(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};


_zzsurvey_ajax.createSurveyInstance = async (data) => { // NOVO 2025-07-12 // POST PUBLIC
  const simEndpoint = 'createSurveyInstance';
  if (simulate) {
    // TODO

  } else { // pravi backend

  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.createSurveyInstance();
    return axios.post(url, data, {
      headers: {
        // 'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        // 'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.fillSurvey = async (id, data) => { // POST // PUBLIC NO TOKEN
  const simEndpoint = 'fillSurvey';
  if (simulate) {
    // TODO

  } else { // pravi backend

  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.fillSurvey(id);
    return axios.post(url, data, {
      headers: {
        // 'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.getSurveyInstance = async (id) => { // GET // PUBLIC NO TOKEN
  const simEndpoint = 'getSurveyInstance';
  if (simulate) {
    // TODO

  } else { // pravi backend

  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.getSurveyInstance(id);
    return axios.get(url, {
      headers: {
        // 'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.getAllSurveyInstancesOfClient = async (status, client_id) => { // GET
  const simEndpoint = 'getAllSurveyInstancesOfClient';
  if (simulate) {
    // TODO

  } else { // pravi backend

  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.getAllSurveyInstancesOfClient(status, client_id);
    return axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};


// ---

_zzsurvey_ajax.getAllReviews = async (data) => { // NEW // POST
  const simEndpoint = 'getAllReviews';
  if (simulate) {
    // TODO

  } else { // pravi backend

  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.getAllReviews();
    const _dummy_reviews_res = {
      data: {
        reviewFormLink: 'http:something.com',
        reviews: [
          {
            rating: 1,
            text: 'Lorem ipsum',
            author_name: 'Alpha',
            author_url: 'http:something.com',
            profile_photo_url: 'http:something.com',
            relative_time_description: 'a week ago',
            language: 'bs',
            original_language: 'bs',
          },
          {
            rating: 2,
            text: 'Lorem ipsum',
            author_name: 'Alpha',
            author_url: 'http:something.com',
            // profile_photo_url: 'http:something.com/something.jpg',
            profile_photo_url: 'https://miro.medium.com/v2/resize:fit:720/format:webp/1*teCls-OOfJW030nB0gDZGA.png',
            profile_photo_url: 'https://miro.medium.com/v2/resize:fill:176:176/1*teCls-OOfJW030nB0gDZGA.png',
            relative_time_description: 'a week ago',
            language: 'sr',
            original_language: 'sr',
          },
        ],
      }
    };
    // return _dummy_reviews_res;
    return axios.post(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};


_zzsurvey_ajax.updateClientParams = async (data) => { // NEW // PUT
  const simEndpoint = 'updateClientParams';
  if (simulate) {
    // TODO

  } else { // pravi backend

  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.updateClientParams();
    return axios.put(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};


// ---


// ---------- CDP/GDPR
_zzsurvey_ajax.createCdpCustomer = async (data) => { // POST
  const simEndpoint = 'createCdpCustomer';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.createCdpCustomer();
    return axios.post(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.getAllCdpCustomersOfClient = async (client_id) => { // GET
  const simEndpoint = 'getAllCdpCustomersOfClient';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.getAllCdpCustomersOfClient(client_id);
    return axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.updateCdpCustomer = async (customer_id, data) => { // PATCH
  const simEndpoint = 'updateCdpCustomer';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.updateCdpCustomer(customer_id);
    return axios.patch(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.deleteCdpCustomer = async (customer_id) => { // GET
  const simEndpoint = 'deleteCdpCustomer';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.deleteCdpCustomer(customer_id);
    return axios.delete(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.importCdpCustomers = async (data) => { // POST
  const simEndpoint = 'importCdpCustomers';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.importCdpCustomers();
    return axios.post(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};



_zzsurvey_ajax.createConsent = async (data) => { // POST
  const simEndpoint = 'createConsent';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.createConsent();
    return axios.post(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.getAllConsentsOfClient = async (client_id) => { // GET
  const simEndpoint = 'getAllConsentsOfClient';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.getAllConsentsOfClient(client_id);
    return axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.getConsent = async (consent_id) => { // GET
  const simEndpoint = 'getConsent';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.getConsent(consent_id);
    return axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};



_zzsurvey_ajax.createSignature = async (data) => { // POST
  const simEndpoint = 'createSignature';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.createSignature();
    return axios.post(url, data, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
        'Content-Type': CONTENT_TYPE_JSON,
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.getAllSignaturesOfClient = async (client_id) => { // GET
  const simEndpoint = 'getAllSignaturesOfClient';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.getAllSignaturesOfClient(client_id);
    return axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};

_zzsurvey_ajax.generateSignatureUrl = async (cdp_customer_id, consent_id) => { // GET
  const simEndpoint = 'generateSignatureUrl';
  if (simulate) {
    // TODO

  } else { // pravi backend
    // let data_prepared = ajax_utils.convert_to_json({ rev_id }); // ENCODE...
    // let response = await ajax_fetch.getmethod_send(apiLib.getVirbomRevParticular(rev_id));
    // return response;
  }
  if (config_solution === 'AXIOS') {
    const url = _zzsurvey_urlLib.generateSignatureUrl(cdp_customer_id, consent_id);
    return axios.get(url, {
      headers: {
        'Authorization': 'Bearer ' + _zzsurvey_authUtils.getToken(),
      }
    })
    // .catch((err) => { error_handle(err.response) })
  }
};
